import React from 'react';
import { Divider, Select } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { KlaviyoTestFormValues } from './KlaviyoTestFormTypes';
import type { SelectOption } from './ProductPlanFields';

export type FromProductPlanFieldsProps = {
	form: UseFormReturnType<KlaviyoTestFormValues>;
	disabled: boolean;
	productOptions: SelectOption[];
	fromProductSubscriptionTypeOptions: SelectOption[];
	/** Overrides the default `getInputProps('fromProductId')` onChange so the parent can reset
	 *  `fromProductSubscriptionTypeId` synchronously when the product changes, instead of via an effect. */
	onFromProductIdChange: (value: string | null) => void;
};

export default function FromProductPlanFields(props: FromProductPlanFieldsProps) {
	const { form, disabled, productOptions, fromProductSubscriptionTypeOptions, onFromProductIdChange } = props;

	return (
		<>
			<Divider label="From product & plan" />
			<Select
				{...form.getInputProps('fromProductId')}
				onChange={onFromProductIdChange}
				label="From product"
				description="The prior plan (upgrades/extensions) or first course purchased (second masterclass)"
				data={productOptions}
				disabled={disabled}
				withAsterisk
				clearable
				searchable
			/>
			<Select
				{...form.getInputProps('fromProductSubscriptionTypeId')}
				label="From subscription type"
				nothingFoundMessage={form.values.fromProductId ? 'No options' : 'Select a product first'}
				data={fromProductSubscriptionTypeOptions}
				disabled={disabled}
				withAsterisk
				clearable
				searchable
			/>
		</>
	);
}
